export default __webpack_public_path__ + "static/char-v-32-316357f1cd815cfd8bdf320858e3fec5.webp";